import React from 'react'
function Footer() {

  return (
    <footer className="bg-blue-600 text-white p-4 text-center mt-8">
      &copy; 2025 LIUSPORTSTRACK. All rights reserved.
    </footer>
  );
};

export default Footer;

